module.exports = __webpack_public_path__ + "img/enviar-icon.14af4e61.svg";